export function Unauthorized(dispatch,r){
    console.log(r)
    if (r !== null && Object.prototype.hasOwnProperty.call(r.response, "status") && r.response.status === 401 && r.response.statusText === 'Unauthorized') {
        dispatch('AuthModule/Logout', null, { root: true });
    }
}